import React, { Component, Fragment } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { toast } from 'react-toastify';

import TextareaAutosize from 'react-autosize-textarea';



import * as Yup from "yup";
import axios from "axios";

const AccountSchema = Yup.object().shape({

      titre: Yup.string()
      .required("Required"),
      message: Yup.string()
      .required("Required")
});

const CustomInputComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => (
  <div>
   <TextareaAutosize style={{ minHeight: 150 }} {...field} {...props}  />
    {touched[field.name] &&
      errors[field.name] && <div className="error">{errors[field.name]}</div>}
  </div>
);


class ContactForm extends Component {
    render() {
      
      return (
        <Fragment>
        <Formik
        ref={(ref) => this.formik = ref}
        initialValues={{ titre:'', message:'' }}
        validationSchema={AccountSchema}
        onSubmit={(values, { setSubmitting }) => {
              axios
                .post("contact/form", {
                  titre: values.titre,
                  message: values.message
                })
                .then(res => {
                  if(res.data.error){
                    toast.error(res.data.error);
                  }
                  if(res.data.success){
                    toast.success(res.data.success);
                    this.formik.resetForm();
                  }
                  setSubmitting(false);
                }).catch(error => {  toast.error(error.message);setSubmitting(false); });
        }}
      >
        {({ isSubmitting }) => (
          <Form style={{ marginBottom: "80px" }}>
            <label htmlFor="titre">Subject</label>
            <Field type="text" name="titre" />
            <ErrorMessage name="titre" component="div" />
            <label htmlFor="message">Message</label>
            <Field  component={CustomInputComponent}  name="message" />
            <ErrorMessage name="message" component="div" />
            
            <button type="submit" disabled={isSubmitting}>
              Send your message
            </button>
          </Form>
        )}
    </Formik>
    </Fragment>
      );
    }
}


export default ContactForm;